import React from 'react'
import Parse from 'parse'

export default class LoginForm extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  readFitFile = (event) => {
    const file = event.target.files[0]

    if (file) {
      this.setState({
        isLoggingFitFile: true
      })
      const reader = new FileReader()
      reader.onload = (e) => {
        const base64 = e.target.result.split(',')[1]
        const params = {
          data: base64
        }
        const fileName = file.name.split('.')[0]
        Parse.Cloud.run('fitFileDebug', params).then((results) => {
          console.log(fileName)
          this.setState({
            output: results,
            isLoggingFitFile: false,
            fileName: fileName
          })
        }, (error) => {
          this.setState({
            isLoggingFitFile: false
          })
          window.alert('Error debugging fit file: ' + error.message)
        })
      }
      reader.onerror = (e) => {
        // error occurred
        console.log('[readFitFile] Error : ' + e.type)
        window.alert('Error getting file: ' + e.message)
      }
      reader.readAsDataURL(file)
    }
  }

  handleDownload = (event) => {
    event.preventDefault()
    this.downloadObjectAsJson(this.state.output, this.state.fileName)
  }

  downloadObjectAsJson = (exportObj, exportName) => {
    const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(exportObj))
    const downloadAnchorNode = document.createElement('a')
    downloadAnchorNode.setAttribute('href', dataStr)
    downloadAnchorNode.setAttribute('download', exportName + '.json')
    document.body.appendChild(downloadAnchorNode) // required for firefox
    downloadAnchorNode.click()
    downloadAnchorNode.remove()
  }

  getGarminWorkoutId = () => {
    const output = this.state.output
    if (output && output.training_file && output.training_file.length > 0) {
      return output.training_file[0].serial_number
    }
    return null
  }

  getGarminConnectWorkout = () => {
    const output = this.state.output
    return output?.garminConnectWorkout || null
  }

  render = () => {
    const garminWorkoutId = this.getGarminWorkoutId()
    const gcw = this.getGarminConnectWorkout()

    return (
        <div className="container">
            <br/>
            <p>{this.state.isLoggingFitFile ? 'Loading...' : 'Upload fit file:'}</p>
            <input disabled={this.state.isLoggingFitFile} type="file" onChange={(event) => { this.readFitFile(event) }} id="file_upload"/>
            <br/><br/>
            <a hidden={!this.state.output} href="#" id="download" onClick={this.handleDownload}>Download</a>

            {garminWorkoutId && (
              <div className="msp-surface p-3 mt-3">
                <h5>Garmin Workout Info</h5>
                <div><strong>Garmin Workout ID: </strong>{garminWorkoutId}</div>

                {gcw && gcw.found && (
                  <div className="alert alert-success mt-2 mb-0">
                    <div><strong>GarminConnectWorkout Found</strong></div>
                    {gcw.workoutId && (
                      <div>
                        <strong>Workout: </strong>
                        <a href={`/#/workouts/${gcw.workoutId}`}>{gcw.workoutTitle || gcw.workoutId}</a>
                      </div>
                    )}
                    {gcw.trainingPlanId && (
                      <div>
                        <strong>Training Plan: </strong>
                        <a href={`/#/trainingplans/${gcw.trainingPlanId}`}>{gcw.trainingPlanId}</a>
                      </div>
                    )}
                    {gcw.trainingPlanEntryId && (
                      <div>
                        <strong>Training Plan Entry: </strong>
                        {gcw.trainingPlanEntryId}
                      </div>
                    )}
                    {gcw.wodId && (
                      <div>
                        <strong>Workout of the Day: </strong>
                        {gcw.wodId}
                      </div>
                    )}
                    {gcw.userId && (
                      <div>
                        <strong>User: </strong>
                        <a href={`/#/members/${gcw.userId}`}>{gcw.userId}</a>
                      </div>
                    )}
                    {gcw.isDeleted && (
                      <div className="text-danger"><strong>Status: </strong>Deleted</div>
                    )}
                  </div>
                )}

                {gcw && !gcw.found && (
                  <div className="alert alert-danger mt-2 mb-0">
                    <strong>GarminConnectWorkout Not Found</strong>
                    {gcw.error && <div>Error: {gcw.error}</div>}
                  </div>
                )}
              </div>
            )}

            <br/>
            <div className="bg-light">
                <pre><code>{JSON.stringify(this.state.output, null, 2)}</code></pre>
            </div>
        </div>
    )
  }
}
